'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  position: relative;\n\n  .react-datepicker {\n    border-radius: 0;\n    border-color: ', ';\n  }\n\n  .react-datepicker__header {\n    border-radius: 0;\n    border-color: ', ';\n  }\n\n  .react-datepicker__time-container {\n    border-color: ', ';\n  }\n\n  .react-datepicker__time-list {\n    padding: 0;\n  }\n\n  .react-datepicker__input-container {\n    width: 100%;\n  }\n\n  .react-datepicker-wrapper {\n    width: 100%;\n  }\n\n  .react-datepicker-popper {\n    z-index: 15;\n    min-width: ', ';\n  }\n\n  .react-datepicker__close-icon::after {\n    background-color: ', ';\n    color: ', ';\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: ', ';\n    line-height: 0;\n  }\n\n  .react-datepicker__close-icon {\n    display: block;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: ', ';\n  }\n\n  .react-datepicker__day:hover {\n    border-radius: 0;\n  }\n\n  .react-datepicker__day--keyboard-selected,\n  .react-datepicker__day--selected,\n  .react-datepicker__day--in-selecting-range,\n  .react-datepicker__day--in-range {\n    border-radius: 0;\n    background-color: ', ';\n    &:hover {\n      background-color: ', ';\n    }\n  }\n'], ['\n  width: 100%;\n  position: relative;\n\n  .react-datepicker {\n    border-radius: 0;\n    border-color: ', ';\n  }\n\n  .react-datepicker__header {\n    border-radius: 0;\n    border-color: ', ';\n  }\n\n  .react-datepicker__time-container {\n    border-color: ', ';\n  }\n\n  .react-datepicker__time-list {\n    padding: 0;\n  }\n\n  .react-datepicker__input-container {\n    width: 100%;\n  }\n\n  .react-datepicker-wrapper {\n    width: 100%;\n  }\n\n  .react-datepicker-popper {\n    z-index: 15;\n    min-width: ', ';\n  }\n\n  .react-datepicker__close-icon::after {\n    background-color: ', ';\n    color: ', ';\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: ', ';\n    line-height: 0;\n  }\n\n  .react-datepicker__close-icon {\n    display: block;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: ', ';\n  }\n\n  .react-datepicker__day:hover {\n    border-radius: 0;\n  }\n\n  .react-datepicker__day--keyboard-selected,\n  .react-datepicker__day--selected,\n  .react-datepicker__day--in-selecting-range,\n  .react-datepicker__day--in-range {\n    border-radius: 0;\n    background-color: ', ';\n    &:hover {\n      background-color: ', ';\n    }\n  }\n']);

var _Input = require('../Input');

Object.defineProperty(exports, 'Input', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Input).default;
  }
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

require('react-datepicker/dist/react-datepicker.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DatePickerWrapper = _styledComponents2.default.div(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return theme.color.separatorColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.color.separatorColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.color.separatorColor;
}, (0, _polished.rem)(320), function (_ref4) {
  var theme = _ref4.theme;
  return theme.color.primary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.color.white;
}, (0, _polished.rem)(15), (0, _polished.rem)(10), function (_ref6) {
  var theme = _ref6.theme;
  return theme.color.primary;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.color.primary;
});

exports.default = DatePickerWrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/oxyrion-ui/lib/DatePickers/DatePickerWrapper.js
// module id = 111
// module chunks = 1